import WorkItemSelectField from "../shared/WorkItemSelectField";

export const WorkItemStatusesForResourceUpdate = [
    {id: 1, name: 'Upcoming'},
    {id: 2, name: 'In Progress'},
    {id: 3, name: 'On Hold'},
    {id: 4, name: 'Pending'},
  ];

interface IWorkItemResourceUpdateSearchFieldStatusProps {
    idSuffix: string,
    onChange: (e: number[]) => void,
    multiple?: boolean
}

const WorkItemResourceUpdateSearchFieldStatus = (props: IWorkItemResourceUpdateSearchFieldStatusProps) => {
    return (
        <>
            <WorkItemSelectField 
                label="Status" 
                idSuffix={props.idSuffix}
                multiple={props.multiple === undefined ? true : props.multiple} 
                options={WorkItemStatusesForResourceUpdate} 
                onChange={s => props.onChange(s)} />
        </>
    );
}

export default WorkItemResourceUpdateSearchFieldStatus;